<template>
  <div>
    <HeaderNoAccess></HeaderNoAccess>
    <div class="d-flex justify-center login-recover-window" style="margin: 10vh auto;">
      <v-card class="elevation-12" style=" width: 500px;">
        <v-card-title class="d-flex justify-center">
          <span style="font-size: larger;">{{ !authSelection ? "Welcome Back!" : "Enter Password" }}</span>
        </v-card-title>
        <v-card-text>
          <div class="pa-4">
            <div class="d-flex" style="flex-direction: column; justify-content: space-between; gap: 12px;">
              <div class="d-flex align-center" style="gap: 12px; position: relative;">
                <v-text-field :disabled="authSelection" v-model="email" label="Email*"
                  :name="authSelection ? 'not-email' : 'email'" type="text" ref="email_input_field"
                  class="text-field-disabled-opacity-override" hide-details
                  v-on:keyup="triggerFindAuthMethodByEnter"></v-text-field>
                <v-icon v-if="authSelection" @click.stop="triggerEmailEditable()" color="#572F7B" size="32px"
                  class="pa-5 data-table-button"
                  style="position: absolute; left: calc(100% - 40px - 12px);">mdi-pencil</v-icon>
              </div>
              <v-text-field v-if="authSelection && email.length >= 1" v-model="password" id="password" label="Password*"
                name="password" type="password" hide-details ref="password_input_field"
                v-on:keyup="triggerLoginByEnter"></v-text-field>
            </div>
          </div>
          <div class="px-4">
            <RouterLink v-if="authSelection" :to="{ name: 'RecoverPassword', query: { 'email': this.email } }"
              class="pl-4 router-link">
              Forgot password?
            </RouterLink>
          </div>
          <div class="pa-4">
            <div class="d-flex" style="flex-direction: column; justify-content: space-between; gap: 12px;">
              <v-btn v-if="!authSelection" @click="triggerauthSelection()" block class="login-button">
                continue
              </v-btn>
              <v-btn v-if="authSelection && email.length >= 1" @click="login()" block class="login-button">
                continue
              </v-btn>
              <div v-if="authSelection && email.length >= 1" style="display: grid; grid-template-columns: 30% 40% 30%;">
                <div class="d-flex" style="align-items: center;">
                  <hr style="width: 100%; color: whitesmoke;">
                </div>
                <span style="text-align: center; color: gray;">OR SIGN IN USING</span>
                <div class="d-flex" style="align-items: center;">
                  <hr style="width: 100%; color: whitesmoke;">
                </div>
              </div>
              <v-btn v-if="authSelection && email.length >= 1" @click="ssoLogin()" block class="login-button">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <img src="../../../assets/Microsoft_icon.svg.png" style="max-height: 24px;" />
                  Microsoft
                </div>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/plugins/backendAPI'
import { mapGetters } from 'vuex';
import HeaderNoAccess from '../../../components/HeaderNoAccess.vue';

export default {
  beforeRouteLeave(to) {
    if (this.$store.getters.redirectRoute !== null && to.fullPath !== this.$store.getters.redirectRoute && this.$store.getters.isauthorized) {
      this.$router.push({
        path: this.$store.getters.redirectRoute,
      });
    } else {
      this.$store.dispatch("setRedirectRoute", null)
    }
  },
  components: {
    HeaderNoAccess
  },
  data() {
    return {
      email: this.$route.query["email"] ?? '',
      password: '',
      authSelection: this.$route.query["auth-selection"] === "true" ? true : false,
      prevRoute: null,
    }
  },
  async created() {
    this.$store.dispatch("setLoading", false)
    if (this.$route.query["error"]) {
      this.$store.dispatch('showError', this.$route.query["error"])
      this.$router.replace({ name: 'AdminSignIn' })
    }
  },
  mounted() {
    this.msalInstance.clearCache();
    console.log("API URL:", process.env.VUE_APP_APIURL);
    console.log("Client API URL:", process.env.VUE_APP_CLIENTURL);
  },
  computed: {
    ...mapGetters(["msalInstance", "userSSOAuthMethod"])
  },
  methods: {
    triggerFindAuthMethodByEnter(e) {
      if (e.keyCode === 13) {
        this.triggerauthSelection()
      }
    },
    triggerLoginByEnter(e) {
      if (e.keyCode === 13) {
        this.login()
      }
    },
    triggerauthSelection() {
      if (this.email) {
        this.authSelection = true
        this.$router.replace({ name: 'AdminSignIn', query: { 'email': this.email, 'auth-selection': true } })
        setTimeout(() => {
          this.$refs.password_input_field.focus()
        }, 200);
        return
      }
      this.$store.dispatch('showError', 'Wrong email or password!')
    },
    triggerEmailEditable() {
      this.password = ""
      this.$router.replace({ name: 'AdminSignIn', query: { 'email': this.email } })
      this.authSelection = false
      setTimeout(() => {
        this.$refs.email_input_field.focus()
      }, 200);
    },
    async findAuthMethod() {
      await this.$store.dispatch('saveUserSSOAuthMethod', null);
      await HTTP.get("/auth/get/method", { params: { email: this.email } }).then(async (response) => {
        await this.$store.dispatch('saveUserSSOAuthMethod', response.data.ssoAuthMethod);
      }).catch(() => {
        throw new Error(`Sign-in request failed.`)
      })
    },
    async ssoLogin() {
      this.$store.dispatch("setLoading", true)
      try {
        await this.findAuthMethod()
        if (this.userSSOAuthMethod === "SAML") {
          delete HTTP.defaults.headers.common['Authorization']
          window.location.href = `${process.env.VUE_APP_APIURL}/auth/sign-in/saml?email=${this.email}${(this.$store.getters.redirectRoute ? `&redirect-to=${this.$store.getters.redirectRoute}` : "")}`
        } else if (this.userSSOAuthMethod === "OIDC") {
          delete HTTP.defaults.headers.common['Authorization']
          const loginRequest = {
            scopes: ["User.Read"],
            loginHint: this.email
          };
          const msalResponse = await this.msalInstance.loginPopup(loginRequest);
          if (msalResponse.idTokenClaims.groups === null) {
            throw new Error("Sign-in request failed: Your account has not yet been activated.")
          }
          await HTTP.post(`/auth/sign-in/oidc${(this.$store.getters.redirectRoute ? `?redirect-to=${this.$store.getters.redirectRoute}` : "")}`, msalResponse.idTokenClaims.groups)
            .then(async (response) => {
              if (response.data.redirectTo) {
                await this.$router.push({ name: "AuthCallback", query: { "auth-method": "OIDC", "redirect-to": response.data.redirectTo, "token": HTTP.defaults.headers.common['Authorization'].substring("Bearer ".length) } })
              } else {
                await this.$router.push({ name: "AuthCallback", query: { "auth-method": "OIDC", "token": HTTP.defaults.headers.common['Authorization'].substring("Bearer ".length) } })
              }
            })
            .catch(async (e) => {
              if (e.response.status === 400) {
                throw new Error(`Sign-in failed: ${e.response.data}`)
              }
              throw new Error(`Sign-in failed: Could not sign in user.`)
            })
        } else {
          throw new Error("Sign-in failed: <br> No Service-Me account has been linked to this microsoft account.")
        }
      } catch (error) {
        this.$router.replace({ name: 'AdminSignIn' })
        this.msalInstance.clearCache()
        this.$store.dispatch('showError', error)
        this.$store.dispatch('saveUserSSOAuthMethod', null)
        this.$store.dispatch('deleteAuthorization')
        this.authSelection = false
        this.email = ''
        this.password = ''
      }
      this.$store.dispatch("setLoading", false)
    },
    async login() {
      try {
        this.$store.dispatch("setLoading", true);

        // No need to await if action is synchronous
        this.$store.dispatch('saveUserSSOAuthMethod', 'NONE');

        // Remove old Authorization header
        delete HTTP.defaults.headers.common['Authorization'];

        // Send login request
        const response = await HTTP.post("/auth/sign-in/jwt", {
          email: this.email,
          password: this.password
        });

        // Set Authorization header for future requests
        const token = response.data.bearer;
        HTTP.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        // Persist token in localStorage for reloads
        localStorage.setItem('authToken', token);

        // Save user info in Vuex
        const user = response.data.user;
        this.$store.dispatch('saveOrganizationId', user.role !== 1 ? user.organizationId : user.ownerOrganizations[0].id);
        this.$store.dispatch('saveLegacyWorkspaceId', response.data.legacyId);
        this.$store.dispatch('saveWorkspaceId', user.workspaceId);
        this.$store.dispatch('saveAuthorization', {
          username: this.email,
          isauthorized: true,
          bearertoken: token,
          isadministrator: user.isAdministrator,
          issuperadministrator: user.isSuperAdministrator
        });

        // Stop loading and redirect
        this.$store.dispatch("setLoading", false);
        this.$router.push({ name: "Issue" });

      } catch (e) {
        // Handle errors
        if (e.response && e.response.status === 400) {
          this.$store.dispatch('showError', `Sign-in request failed: ${e.response.data}`);
        } else {
          this.$store.dispatch('showError', 'Sign-in request failed: Wrong email or password!');
        }

        // Reset state
        this.$router.replace({ name: 'AdminSignIn' });
        this.$store.dispatch('saveUserSSOAuthMethod', null);
        this.$store.dispatch('deleteAuthorization');
        this.email = '';
        this.password = '';
        this.authSelection = false;
        this.$store.dispatch("setLoading", false);
      }
    },
    recoverpassword() {
      this.$router.push({ name: 'RecoverPassword' })
    }
  }
}
</script>

<style scoped lang="css">
.additional-login-info {
  margin-bottom: 25px;
  text-align: center;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-weight: bolder;
  color: lightcoral;
}
</style>
